import { Box, Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { SubscriptionFreezeStatus } from 'proto/billing-manager_pb';
import { FREEZE_BANNER, freezeStatusCopy } from '../content';
import { formatFreezeDate } from '../formatters';
import { freezeOwnsPath, freezeReturnPath } from '../freezeLock';
import { useSubscriptionFreeze } from '../SubscriptionFreezeContext';
import { AlertTone, FreezeSoftAlert, FreezeStatusTone } from './freezeUi';

const ALERT_TONES: Record<FreezeStatusTone, AlertTone> = { ice: 'info', warm: 'info', warning: 'warning', error: 'error' };

/** While a pause is open the app stays usable, so every page but the pause's own says so and offers the way back. */
export default function PausedPlanBanner() {
  const { freeze } = useSubscriptionFreeze();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  if (!freeze || freezeOwnsPath(pathname)) return null;

  const copy = freezeStatusCopy(freeze);
  const paused = freeze.status === SubscriptionFreezeStatus.SUBSCRIPTION_FREEZE_STATUS_FROZEN;
  const body = paused ? `${FREEZE_BANNER.resumesOn(formatFreezeDate(freeze.plannedResumeAt))} ${FREEZE_BANNER.whilePaused}` : copy.body;

  return (
    <Box sx={{ mb: 2.5 }}>
      <FreezeSoftAlert
        tone={ALERT_TONES[copy.tone]}
        title={copy.title}
        action={
          <Button size="small" variant={paused ? 'contained' : 'outlined'} onClick={() => navigate(freezeReturnPath(freeze))}>
            {paused ? FREEZE_BANNER.resumeNow : FREEZE_BANNER.viewStatus}
          </Button>
        }
      >
        {body}
      </FreezeSoftAlert>
    </Box>
  );
}
